/*
 * Copyright (c) 2004-2019 Paul Blacknell. All rights reserved.
 * https://github.com/blacknell
 */

import React, {Component, Fragment} from 'react';
import {UncontrolledTooltip} from 'reactstrap';

class WeatherForecast extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }

    render() {

        const {weather, date} = this.props;

        let wiIconClassName = '';
        let wiIconId;
        let wiWeatherSummary = '';

        for (let i = 0; weather.daily && i < weather.daily.data.length; i++) {
            if (weather.daily.data[i].date.isSame(date)) {

                // dark sky mappings derived from https://github.com/erikflowers/weather-icons/blob/master/less/mappings/wi-forecast-io.less
                switch (weather.daily.data[i].icon) {
                    default:
                    case 'day-sunny':
                    case 'clear-day':
                        wiIconClassName = 'wi wi-forecast-io-clear-day';
                        break;
                    case 'night-clear':
                        wiIconClassName = 'wi wi-forecast-io-clear-night';
                        break;
                    case 'rain':
                        wiIconClassName = 'wi wi-forecast-io-rain';
                        break;
                    case 'snow':
                        wiIconClassName = 'wi wi-forecast-io-snow';
                        break;
                    case 'sleet':
                        wiIconClassName = 'wi wi-forecast-io-sleet';
                        break;
                    case 'fog':
                        wiIconClassName = 'wi wi-forecast-io-fog';
                        break;
                    case 'cloudy':
                        wiIconClassName = 'wi wi-forecast-io-cloudy';
                        break;
                    case 'day-cloudy':
                        wiIconClassName = 'wi wi-forecast-io-partly-cloudy-day';
                        break;
                    case 'night-cloudy':
                        wiIconClassName = 'wi wi-forecast-io-partly-cloudy-night';
                        break;
                    case 'hail':
                        wiIconClassName = 'wi wi-forecast-io-hail';
                        break;
                    case 'thunderstorm':
                        wiIconClassName = 'wi wi-forecast-io-thunderstorm';
                        break;
                    case 'tornado':
                        wiIconClassName = 'wi wi-forecast-io-tornado';
                        break;
                }

                wiWeatherSummary = weather.daily.data[i].summary;
                wiIconId = weather.daily.data[i].time;
            }
        }

        return (
            wiIconClassName !== '' && wiWeatherSummary !== '' &&
            <Fragment><i id={'W' + wiIconId} className={wiIconClassName+" mt-1"}/>
                <UncontrolledTooltip target={'W' + wiIconId} placement="top">{wiWeatherSummary}</UncontrolledTooltip>
            </Fragment>
        );
    }
}

export default WeatherForecast;